// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "table[data-v-afc6b6b6]{width:100%}table[data-v-afc6b6b6],table td[data-v-afc6b6b6]{border:1px solid #888}table td[data-v-afc6b6b6]{padding:8px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
